import { render, staticRenderFns } from "./GoalKeeperDialog.vue?vue&type=template&id=3cdc2cf0&scoped=true"
import script from "./GoalKeeperDialog.vue?vue&type=script&lang=js"
export * from "./GoalKeeperDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdc2cf0",
  null
  
)

export default component.exports